export default __webpack_public_path__ + "static/media/stars_hair_design.234d7661.png";